import type { $Keys } from 'utility-types'

import { FieldTypes } from 'modules/custom_resources/store/collections/customFields/fields'

type FieldTypesEnum = $Keys<typeof FieldTypes>

const getValueType = (fieldType: FieldTypesEnum): string => {
  switch (fieldType) {
    case FieldTypes.text:
      return 'string'

    case FieldTypes.date:
      return 'date'

    case FieldTypes.longText:
      return 'string'

    case FieldTypes.checkbox:
      return 'boolean'

    case FieldTypes.cents:
      return 'cents'

    case FieldTypes.money:
      return 'cents'

    case FieldTypes.singleChoice:
      return 'string'

    case FieldTypes.multipleChoice:
      return 'any'

    case FieldTypes.rating:
      return 'any'

    default:
      throw new Error(`The FieldType ${fieldType} doesn't exist`)
  }
}

export default getValueType
